/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Personalallowedtouseprinter4Inputs */

const de__field_personalallowedtouseprinter4 = /** @type {(inputs: _Field_Personalallowedtouseprinter4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drucker/Kopierer benutzbar`)
};

/**

* @param {_Field_Personalallowedtouseprinter4Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_personalallowedtouseprinter4 = /** @type {((inputs?: _Field_Personalallowedtouseprinter4Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Personalallowedtouseprinter4Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_personalallowedtouseprinter4(inputs)
});
export { _field_personalallowedtouseprinter4 as "_field_personalAllowedToUsePrinter" }